var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfLabelsCall()}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" TEXT LABELS\n")],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bde5ec98","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/LabelsSmallText.vue
// module id = CVtG
// module chunks = 1